import React, { useState } from 'react';
import { LinkIcon } from '@heroicons/react/24/solid';
import { useSendMessageMutation } from '../../../redux/apis/endpoints/messageApi';
import { useSelector } from 'react-redux';
import { toast } from 'react-hot-toast';

const MessageContextButton = ({ fulfillmentGroupId, recipientId, size = 'default' }) => {
  const [sendMessage, { isLoading }] = useSendMessageMutation();
  const [sendingContext, setSendingContext] = useState(false);
  const { user } = useSelector(state => state.auth);

  const handleSendContext = async () => {
    if (!recipientId || !fulfillmentGroupId || sendingContext || !user) return;
    
    try {
      setSendingContext(true);
      
      // Ensure fulfillmentGroupId is properly formatted (as a string ID)
      const normalizedFgId = typeof fulfillmentGroupId === 'object' 
        ? (fulfillmentGroupId.id || fulfillmentGroupId.toString()) 
        : fulfillmentGroupId;
          
      console.log('Sending context message for FG:', normalizedFgId, 'to recipient:', recipientId);
      
      // Instead of sending empty text, send a minimal placeholder
      // Strapi might require non-empty messageText
      const contextMessage = `Order Context (FG-${normalizedFgId})`;
      
      const response = await sendMessage({
        receiverId: recipientId,
        text: contextMessage, // Using minimal text instead of empty string
        fulfillmentGroupId: normalizedFgId, 
        senderId: user.id,
        messageType: "fulfillment_context" // Special message type
      }).unwrap();
      
      console.log('Context message sent successfully:', response);
      toast.success('Order context shared successfully');
    } catch (error) {
      console.error('Failed to send context:', error);
      toast.error(`Failed to share order context: ${error.message || 'Unknown error'}`);
    } finally {
      setSendingContext(false);
    }
  };

  // Define size-specific classes
  const sizeClasses = {
    small: 'px-2 py-1 text-xs',
    default: 'px-3 py-1.5 text-xs',
    large: 'px-4 py-2 text-sm'
  };
  
  const iconSizeClasses = {
    small: 'h-3 w-3 mr-1',
    default: 'h-3.5 w-3.5 mr-1.5',
    large: 'h-4 w-4 mr-2'
  };

  return (
    <button
      type="button"
      onClick={handleSendContext}
      disabled={sendingContext || isLoading}
      className={`inline-flex items-center font-medium rounded-md shadow-sm text-white bg-brand-teal focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-teal ${
        sendingContext || isLoading ? 'opacity-70 cursor-not-allowed' : 'hover:bg-brand-teal-dark'
      } ${sizeClasses[size]}`}
    >
      <LinkIcon className={iconSizeClasses[size]} />
      <span>{sendingContext ? 'Sending...' : 'Send Context'}</span>
    </button>
  );
};

export default MessageContextButton; 